import { Component, Input, OnInit } from '@angular/core';
import { OrderReceiptState } from 'src/app/models/order-receipt/orderReceiptState';
import { OrderReceiptOrder } from 'src/app/models/order-receipt/orderReceiptOrder';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'order-receipt',
    standalone: true,
    templateUrl: './order-receipt.html',
    imports: [
        CommonModule,
    ]
})
export class OrderReceiptComponent implements OnInit {

  @Input() public orderReceipt: any = {} as OrderReceiptState;

  // Upsell tax only counts toward the receipt total when the sales-tax service is on.
  public taxServiceEnabled: boolean = (window as any)['process_env'].IS_ENABLED_SALESTAX;

  public upsellsTotal: number = 0;
  public upsellsTotalTax: number = 0;
  public upsellsShippingCost: number = 0;

  public order: OrderReceiptOrder = {} as OrderReceiptOrder;

  ngOnInit() {
    this.init();
  }

  private init() {
    if (!this.orderReceipt) return;

    this.order = this.orderReceipt.orderDetails
      ? this.orderReceipt.orderDetails.order
        ? this.orderReceipt.orderDetails.order
        : this.orderReceipt.orderDetails
      : {} as OrderReceiptOrder;

    const upsells: Array<OrderReceiptOrder> = this.orderReceipt.upsells;
    if (upsells && upsells.length > 0) {
      for (const upsell of upsells) {
        this.upsellsTotal += upsell.total;
        // Check if tax Service Enabled and Upsell order have a tax then we calculate tax amount for upsells
        if (this.taxServiceEnabled && upsell.tax) {
          this.upsellsTotalTax += upsell.tax;
        }
        this.upsellsShippingCost += upsell.orderShippingCost;
      }
    }
  }

}

